import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import MiniLoader from "../../layout2.0/UI/MiniLoader";
import { Link } from "react-router-dom";
import { currentWidget, setRegPage, showGuestItinerary } from "../../action/action";
import { formatLocalTime, toBool } from "../../layout2.0/JS/utility";
import { dateFormatHandler } from "../../JS/dateFormatHandler";
import { setLoginRequired } from "../../layout2.0/action/homeAction";


const GuestItineraryHomepage = (props) => {

    const { t } = props;
    let room = localStorage.getItem("room");
    const [widgetData, setCurrentWidgetData] = useState({});
    const [upcomingItineraryGroups, setUpcomingItineraryGroups] = useState([]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const today = props.serverTimeDate ? new Date(props.serverTimeDate.split("T")[0]) : new Date();

        // Clear the time part for comparison
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
        const diffInTime = date.getTime() - today.getTime();
        const diffInDays = diffInTime / oneDayInMilliseconds;

        if (diffInDays === 0) {
            return "Today";
        } else if (diffInDays === -1) {
            return "Yesterday";
        } else if (diffInDays === 1) {
            return "Tomorrow";
        } else {
            return dateFormatHandler(new Date(dateString).toISOString(), props.dateFormat)
        }
    };

    const showLoginPopup = () => {
        if (process.env.REACT_APP_INROOMTAB == "true") {
            props.setLoginRequired(true)
        } else {
            props.setRegPage(true);
        }
    }

    const onWidgetClick = () => {
        props.currentWidget(widgetData);
    }

    const handleShowItineraryDetails = (itinerary) => {
        props.showGuestItinerary(true, itinerary)
    }

    const filterUpcomingItineraries = (itineraryGroups) => {
        const today = props.serverTimeDate ? new Date(props.serverTimeDate.split("T")[0]) : new Date();
        today.setHours(0, 0, 0, 0);

        return itineraryGroups.filter(itineraryGroup => {
            const itineraryDate = new Date(itineraryGroup.itineraryDate);
            itineraryDate.setHours(0, 0, 0, 0);
            return itineraryDate >= today;
        });
    };

    React.useEffect(() => {
        const guestItineraryWidget = props.widgetList.find((obj) => obj.widgetType == "Guest Itinerary");
        setCurrentWidgetData(guestItineraryWidget);

        const upcomingItineraryGroups_var = filterUpcomingItineraries(props.guest_itinerary.payload)
        setUpcomingItineraryGroups(upcomingItineraryGroups_var);

        console.log("Guest Itinerary Data:")
        console.log(props.guest_itinerary)
        console.log(guestItineraryWidget)
        console.log(props.serverTimeDate)

    }, [props.guest_itinerary])

    return (
        <>
            <div class="gallery-slides itinerary-list">
                <div class="form-row-heading">
                    {widgetData.widgetTitle} <Link exact to={widgetData.path || "/"} onClick={onWidgetClick} class="inline-link">{t('guest_itinerary.my_reservations')}</Link>
                </div>

                {
                    ((!room || room == 'null') && !(localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))) ?
                        <div class="list-items-container">
                            <div onClick={showLoginPopup} class="list-item-heading no-reservations">{t('guest_itinerary.login_room')}</div>
                        </div>

                        :

                        props.guest_itinerary.status == "PENDING" || !props.serverTimeDate ?

                            <MiniLoader />

                            : props.guest_itinerary.status == "SUCCESS" ?

                                props.guest_itinerary.payload.length == 0 ?

                                    <div class="list-items-container">
                                        <div class="list-item-heading no-reservations">{t('guest_itinerary.no_reservation_found')}</div>
                                    </div>

                                    :
                                    
                                    upcomingItineraryGroups.length === 0 ?
                                        <div className="list-items-container">
                                            <div className="list-item-heading no-reservations">{t('guest_itinerary.no_upcoming_reservations')}</div>
                                        </div>
                                        :

                                        upcomingItineraryGroups.map((itineraryGroup) => {
                                            return (
                                                <div class="list-items-container">
                                                    <div class="list-item-heading">{formatDate(itineraryGroup.itineraryDate)}</div>

                                                    {itineraryGroup.itineraries.map((itinerary) => {
                                                        return (
                                                            <div class="list-item">
                                                                <div class="list-item-contents">
                                                                    <div class="list-item-name">{itinerary.itineraryName}</div>
                                                                    <div class="list-item-body">{formatLocalTime(new Date((itinerary.itineraryDateTime)), toBool(props.timeFormat))}</div>
                                                                </div>
                                                                <div onClick={() => handleShowItineraryDetails(itinerary)} class="list-item-opt">
                                                                    <button>...</button>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })
                                :
                                <div class="list-items-container">
                                    <div class="list-item-heading no-reservations">{t('guest_itinerary.something_went_wrong')}</div>
                                </div>
                }
            </div>
        </>
    )
}

GuestItineraryHomepage.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        timeFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM : true,
        guest_itinerary: state.store2.guest_itinerary,
    }
}
export default connect(mapStateToProps, { currentWidget, setLoginRequired, setRegPage, showGuestItinerary })(withTranslation('translations')(GuestItineraryHomepage));